import type { MessageKey } from 'types/LocaleMessageKey';

export interface ProfileData {
  bioKey: MessageKey;
  dailyHabitKey: MessageKey;
  id: string;
  imageUrl: string;
  name: string;
  quoteKey?: MessageKey;
  titleKey: MessageKey;
}

const TomHale: ProfileData = {
  bioKey: 'leadership_bio_tom_hale',
  dailyHabitKey: 'leadership_daily_habit_tom_hale',
  id: 'tom_hale',
  imageUrl: 'leadership/tom-hale',
  name: 'Tom Hale',
  quoteKey: 'leadership_quote_tom_hale',
  titleKey: 'leadership_ceo',
};

const MichaelChapp: ProfileData = {
  bioKey: 'leadership_bio_michael_chapp',
  dailyHabitKey: 'leadership_daily_habit_michael_chapp',
  id: 'michael_chapp',
  imageUrl: 'leadership/michael-chapp',
  name: 'Michael Chapp',
  quoteKey: 'leadership_quote_michael_chapp',
  titleKey: 'leadership_coo',
};

const DougSweeny: ProfileData = {
  bioKey: 'leadership_bio_doug_sweeny',
  dailyHabitKey: 'leadership_daily_habit_doug_sweeny',
  id: 'doug_sweeney',
  imageUrl: 'leadership/doug-sweeny',
  name: 'Doug Sweeny',
  quoteKey: 'leadership_quote_doug_sweeny',
  titleKey: 'leadership_cmo',
};

const HollyShelton: ProfileData = {
  bioKey: 'leadership_bio_holly_shelton',
  dailyHabitKey: 'leadership_daily_habit_holly_shelton',
  id: 'holly_shelton',
  imageUrl: 'leadership/holly-shelton',
  name: 'Holly Shelton',
  quoteKey: 'leadership_quote_holly_shelton',
  titleKey: 'leadership_cpo',
};

const DorothyKilroy: ProfileData = {
  bioKey: 'leadership_bio_dorothy_kilroy',
  dailyHabitKey: 'leadership_daily_habit_dorothy_kilroy',
  id: 'dorothy_kilroy',
  imageUrl: 'leadership/dorothy-kilroy',
  name: 'Dorothy Kilroy',
  quoteKey: 'leadership_quote_dorothy_kilroy',
  titleKey: 'leadership_cco',
};

const SheetalShah: ProfileData = {
  bioKey: 'leadership_sheetal_bio',
  dailyHabitKey: 'leadership_sheetal_daily_habit',
  id: 'sheetal_shah',
  imageUrl: 'leadership/sheetal-shah',
  name: 'Sheetal Shah',
  quoteKey: 'leadership_sheetal_quote',
  titleKey: 'leadership_sheetal_title',
};

const JudyGilbert: ProfileData = {
  bioKey: 'leadership_bio_judy_gilbert',
  dailyHabitKey: 'leadership_daily_habit_judy_gilbert',
  id: 'judy_gilbert',
  imageUrl: 'leadership/judy-gilbert-profile',
  name: 'Judy Gilbert',
  quoteKey: 'leadership_quote_judy_gilbert',
  titleKey: 'leadership_chro',
};

const AvonteCampinhaBacote: ProfileData = {
  bioKey: 'leadership_bio_avonte_campinha_bacote',
  dailyHabitKey: 'leadership_daily_habit_avonte_campinha_bacote',
  id: 'avonte_campinha_bacote',
  imageUrl: 'leadership/avonte-campinha-bacote',
  name: 'Avonte Campinha-Bacote',
  quoteKey: 'leadership_quote_avonte_campinha_bacote',
  titleKey: 'leadership_gc',
};

const ShyamalPatel: ProfileData = {
  bioKey: 'leadership_shyamal_patel_bio_v2',
  dailyHabitKey: 'leadership_daily_habit_shyamal_patel',
  id: 'shyamal_patel',
  imageUrl: 'leadership/shyamal-patel',
  name: 'Shyamal Patel',
  quoteKey: 'leadership_quote_shyamal_patel',
  titleKey: 'leadership_svp_science',
};

const TommiHeinonen: ProfileData = {
  bioKey: 'leadership_bio_tommi_heinonen',
  dailyHabitKey: 'leadership_daily_habit_tommi_heinonen',
  id: 'tommi_heinonen',
  imageUrl: 'leadership/tommi-heinonen',
  name: 'Tommi Heinonen',
  quoteKey: 'leadership_quote_tommi_heinonen',
  titleKey: 'leadership_svp_hardware',
};

const AdiShammout: ProfileData = {
  bioKey: 'leadership_bio_adi_shammout',
  dailyHabitKey: 'leadership_daily_habit_adi_shammout',
  id: 'adi_shammout',
  imageUrl: 'leadership/adi-shammout',
  name: 'Adi Shammout',
  quoteKey: 'leadership_quote_adi_shammout',
  titleKey: 'leadership_ciso',
};

const SeanBrecker: ProfileData = {
  bioKey: 'leadership_bio_sean_brecker',
  dailyHabitKey: 'leadership_daily_habit_sean_brecker',
  id: 'sean_brecker',
  imageUrl: 'leadership/sean-brecker',
  name: 'Sean Brecker',
  quoteKey: 'leadership_quote_sean_brecker',
  titleKey: 'leadership_cfo',
};

const KateBrinks: ProfileData = {
  bioKey: 'leadership_bio_kate_brinks',
  dailyHabitKey: 'leadership_daily_habit_kate_brinks',
  id: 'kate_brinks',
  imageUrl: 'leadership/kate-brinks',
  name: 'Kate Brinks',
  quoteKey: 'leadership_quote_kate_brinks',
  titleKey: 'leadership_vp_communications',
};

const LauriVuornos: ProfileData = {
  bioKey: 'leadership_bio_lauri_vuornos',
  dailyHabitKey: 'leadership_daily_habit_lauri_vuornos',
  id: 'lauri_vuornos',
  imageUrl: 'leadership/lauri-vuornos',
  name: 'Lauri Vuornos',
  titleKey: 'leadership_svp_software_engineering',
};

const MikluSilvanto: ProfileData = {
  bioKey: 'leadership_miklu_silvanto_description_updated',
  dailyHabitKey: 'leadership_miklu_silvanto_daily_habit',
  id: 'miklu_silvanto',
  imageUrl: 'leadership/miklu-silvanto',
  name: 'Miklu Silvanto',
  quoteKey: 'leadership_miklu_silvanto_quote',
  titleKey: 'leadership_chief_design_officer',
};

export const profilesRows: ProfileData[][] = [
  [TomHale, MichaelChapp],
  [JudyGilbert, SeanBrecker],
  [HollyShelton, DougSweeny],
  [DorothyKilroy, SheetalShah],
  [AdiShammout, AvonteCampinhaBacote],
  [KateBrinks, ShyamalPatel],
  [LauriVuornos, TommiHeinonen],
  [MikluSilvanto],
];
